module.exports = "/_next/static/images/banner_ebook_id-981df40180168e6e5791febc22054a59.jpg";